module.exports = __webpack_public_path__ + "media/images/elionline/icons/download_invite-c87a053d0ca294f0598876a141c5903d.svg";